<div class="modal-content">
  <div class="modal-header text-center">
    <button type="button" class="close" aria-label="Fechar" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
    <div class="icon checked"></div>
    <h3 class="modal-title">TOKEN ENVIADO</h3>
    <small>Seu cliente irá receber uma mensagem de texto com o código Token. Por gentileza, passe o controle do sistema para o Cliente para que ele possa continuar com a assinatura digital.</small>
  </div>
  <div class="modal-footer">
      <a class="btn btn-full-orange" [href]="urlContrato">Abrir Contratos</a>
  </div>
</div>
